import MenuIcon from '@mui/icons-material/Menu'
import {
  AppBar,
  Box,
  Button,
  Container,
  IconButton,
  Menu,
  MenuItem,
  Toolbar,
  Typography
} from '@mui/material'
import { useState } from 'react'
import { Link as RouterLink, useLocation } from 'react-router-dom'
import WoodworkLogo from './Work/WoodworkLogo'
import './Work/WoodworkLogo.css'

interface Page {
  readonly label: string
  readonly path: string
}

const pages: Page[] = [
  { label: 'Work', path: '/work' },
  { label: 'Lab', path: '/lab' },
  { label: 'Diving Dads', path: '/diving-dads' }
]

const NavBar = () => {
  const [anchorElNav, setAnchorElNav] = useState<null | HTMLElement>(null)
  const location = useLocation()
  const isHome = location.pathname === '/'

  const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElNav(event.currentTarget)
  }

  const handleCloseNavMenu = () => {
    setAnchorElNav(null)
  }

  return (
    <AppBar
      position='sticky'
      elevation={0}
      sx={{
        backgroundColor: isHome ? 'rgba(15, 14, 12, 0.55)' : 'rgba(26, 24, 20, 0.92)',
        backdropFilter: 'blur(12px)',
        borderBottom: '1px solid',
        borderColor: 'rgba(255, 255, 255, 0.06)'
      }}
    >
      <Container maxWidth='lg'>
        <Toolbar disableGutters sx={{ minHeight: { xs: 56, md: 64 } }}>
          <Typography
            variant='h6'
            noWrap
            component={RouterLink}
            to='/'
            className='work-brand-lockup'
            sx={{
              mr: 3,
              display: { xs: 'none', md: 'inline-flex' },
              fontFamily: '"Fraunces", Georgia, serif',
              fontSize: '1.3rem',
              fontWeight: 500,
              letterSpacing: '0.06em',
              color: 'inherit',
              textDecoration: 'none',
              transition: 'color 0.2s ease',
              '&:hover': { color: 'primary.main' }
            }}
          >
            <WoodworkLogo variant='leaf' size='nav' aria-hidden />
            Tristan J. Hall
          </Typography>

          <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
            <IconButton
              size='large'
              aria-label='open navigation menu'
              aria-controls='menu-appbar'
              aria-haspopup='true'
              onClick={handleOpenNavMenu}
              color='inherit'
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id='menu-appbar'
              anchorEl={anchorElNav}
              anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
              keepMounted
              transformOrigin={{ vertical: 'top', horizontal: 'left' }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{ display: { xs: 'block', md: 'none' } }}
              PaperProps={{
                sx: {
                  backgroundColor: 'background.paper',
                  border: '1px solid',
                  borderColor: 'rgba(255,255,255,0.07)',
                  mt: 1
                }
              }}
            >
              {pages.map((page) => (
                <MenuItem
                  key={page.label}
                  onClick={handleCloseNavMenu}
                  component={RouterLink}
                  to={page.path}
                >
                  <Typography textAlign='center' color='text.primary'>
                    {page.label}
                  </Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>

          <Typography
            variant='h6'
            noWrap
            component={RouterLink}
            to='/'
            className='work-brand-lockup'
            sx={{
              mr: 2,
              display: { xs: 'inline-flex', md: 'none' },
              flexGrow: 1,
              fontFamily: '"Fraunces", Georgia, serif',
              fontSize: '1.15rem',
              fontWeight: 500,
              letterSpacing: '0.04em',
              color: 'inherit',
              textDecoration: 'none'
            }}
          >
            <WoodworkLogo variant='leaf' size='nav' aria-hidden />
            Tristan J. Hall
          </Typography>

          <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' }, gap: 0.5 }}>
            {pages.map((page) => (
              <Button
                key={page.label}
                component={RouterLink}
                to={page.path}
                sx={{
                  my: 1,
                  px: 2,
                  color: location.pathname.startsWith(page.path)
                    ? 'primary.main'
                    : 'text.secondary',
                  fontSize: '0.9rem',
                  letterSpacing: '0.06em',
                  '&:hover': {
                    color: 'primary.main',
                    backgroundColor: 'rgba(201, 162, 39, 0.08)'
                  }
                }}
              >
                {page.label}
              </Button>
            ))}
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  )
}

export default NavBar
